import Vue from 'vue'

export default new Vue()

/**
  // 页面中有$on事件的 在实例销毁之前，要移除监听器
  beforeDestroy () {
    broadcast.$off("change-event")
  }
 */


// WEBPACK FOOTER //
// ./src/assets/broadcast.js